module.exports = __webpack_public_path__ + "img/emeet-header@2x.1579d4ef.png";